// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== NAVBAR CSS ========== */
:root {
  --primary-gray: #d9d9d9;
  --white: #ffffff;
  --black: #000000;
  --transparent: rgba(255, 255, 255, 0.1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.navbar {
  background: var(--transparent);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(217, 217, 217, 0.1);
  transition: all 0.3s ease;
  z-index: 99999; /* Z-index foarte mare pentru navbar */
  position: relative;
}

/* Sticky only on desktop */
@media (min-width: 769px) {
  .navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999; /* Păstrează z-index mare pentru fixed position */
  }
  
  /* Add padding to body to compensate for fixed navbar */
  body {
    padding-top: 80px;
  }
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background-color: #ffffff;
  z-index: 99999;
}

/* Logo Styles */
.navbar-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: bold;
  color: var(--white);
  z-index: 99999;
  position: relative;
}

.logo-f {
  background: var(--primary-gray);
  color: var(--black);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: bold;
}

.logo-text {
  color: #000000;
  font-size: 1.6rem;
  letter-spacing: 2px;
  font-weight: 400;
}

/* Desktop Menu */
.desktop-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
  z-index: 99999;
  position: relative;
}

.desktop-menu li a {
  color: var(--black);
  text-decoration: none;
  font-weight: 400;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 0;
}

.desktop-menu li a:hover {
  color: var(--black);
}

.desktop-menu li a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background: var(--white);
  transition: width 0.3s ease;
}

.desktop-menu li a:hover::after {
  width: 100%;
}

/* Mobile Menu Button */
.mobile-menu-button {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 100001; /* Cel mai mare z-index pentru butonul hamburger */
  position: relative;
}

.hamburger {
  width: 25px;
  height: 2px;
  background: rgb(110, 110, 110);
  margin: 3px 0;
  transition: all 0.3s ease;
  transform-origin: center;
}

.mobile-menu-button.active .hamburger:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.mobile-menu-button.active .hamburger:nth-child(2) {
  opacity: 0;
}

.mobile-menu-button.active .hamburger:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 280px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.95); /* Background solid pentru vizibilitate */
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  transition: right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 100000; /* Z-index foarte mare pentru meniul mobil */
}

.mobile-menu.active {
  right: 0;
}

.mobile-menu-items {
  list-style: none;
  padding: 100px 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 100000;
  position: relative;
}

.mobile-menu-items li {
  opacity: 0;
  transform: translateX(30px);
  transition: all 0.3s ease;
  transition-delay: 0.1s;
  z-index: 100000;
  position: relative;
}

.mobile-menu.active .mobile-menu-items li {
  opacity: 1;
  transform: translateX(0);
}

.mobile-menu-items li:nth-child(1) { transition-delay: 0.1s; }
.mobile-menu-items li:nth-child(2) { transition-delay: 0.15s; }
.mobile-menu-items li:nth-child(3) { transition-delay: 0.2s; }
.mobile-menu-items li:nth-child(4) { transition-delay: 0.25s; }
.mobile-menu-items li:nth-child(5) { transition-delay: 0.3s; }
.mobile-menu-items li:nth-child(6) { transition-delay: 0.35s; }

.mobile-menu-items li a {
  color: var(--primary-gray);
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 300;
  padding: 1rem 0;
  display: block;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(217, 217, 217, 0.1);
  position: relative;
  z-index: 100000;
}

.mobile-menu-items li a:hover {
  color: var(--white);
  padding-left: 1rem;
}

/* Menu Overlay */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 99998; /* Sub meniu dar deasupra hero */
}

.menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Responsive Design */
@media (max-width: 768px) {
  .navbar {
    z-index: 99999; /* Păstrează z-index mare pe mobil */
  }
  
  .navbar-container {
    padding: 1rem 1.5rem;
    z-index: 99999;
  }
  
  .desktop-menu {
    display: none;
  }
  
  .mobile-menu-button {
    display: flex;
    z-index: 100001; /* Cel mai mare z-index pe mobil */
  }
  
  .logo-text {
    font-size: 1rem;
    letter-spacing: 1.5px;
  }
  
  .logo-f {
    width: 28px;
    height: 28px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    padding: 1rem 1rem;
    z-index: 99999;
  }
  
  .mobile-menu {
    width: 100%;
    z-index: 100000;
  }
  
  .mobile-menu-items {
    padding: 80px 2rem 2rem;
    z-index: 100000;
  }
}

/* Smooth scrolling for anchor links */
html {
  scroll-behavior: smooth;
}

/* Hide scrollbar when menu is open */
body.menu-open {
  overflow: hidden;
}

/* ========== HERO CAROUSEL CSS ========== */

.hero-carousel {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  background: var(--black);
  z-index: 1; /* Z-index mic pentru hero carousel */
}

.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* Slides */
.slides-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1;
}

.slide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0.1) 100%
  );
  z-index: 2;
}

.slide-content {
  position: relative;
  z-index: 3; /* Doar pentru conținutul slide-ului, nu pentru întreaga secțiune */
  max-width: 1200px;
  padding: 0 2rem;
  margin-left: 0;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  transition-delay: 0.3s;
}

.slide.active .slide-content {
  opacity: 1;
  transform: translateY(0);
}

.slide-title {
  font-size: clamp(2.5rem, 8vw, 6rem);
  font-weight: 300;
  color: var(--white);
  margin: 0 0 1rem 0;
  line-height: 1.1;
  letter-spacing: -2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  max-width: 800px;
}

.slide-subtitle {
  font-size: clamp(1.1rem, 2vw, 1.5rem);
  color: var(--primary-gray);
  margin: 0 0 2rem 0;
  font-weight: 300;
  opacity: 0.9;
  line-height: 1.4;
  max-width: 600px;
}

.slide-button {
  background: transparent;
  border: 2px solid var(--white);
  color: var(--white);
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.slide-button:hover {
  background: var(--white);
  color: var(--black);
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2);
}

.slide-button svg {
  transition: transform 0.3s ease;
}

.slide-button:hover svg {
  transform: translateX(5px);
}

/* Navigation Arrows */
.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--white);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 5; /* Z-index mic pentru elementele carousel-ului */
  opacity: 0.7;
}

.carousel-arrow:hover {
  background: rgba(255, 255, 255, 0.2);
  opacity: 1;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.carousel-arrow-left {
  left: 2rem;
}

.carousel-arrow-right {
  right: 2rem;
}

/* Dots Indicator */
.carousel-dots {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
  z-index: 5; /* Z-index mic pentru dots */
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: var(--white);
  transform: scale(1.2);
}

.dot:hover:not(.active) {
  background: rgba(255, 255, 255, 0.6);
  transform: scale(1.1);
}

/* Progress Bar */
.carousel-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  z-index: 5; /* Z-index mic pentru progress bar */
}

.progress-bar {
  height: 100%;
  background: var(--white);
  width: 0;
  animation: progressAnimation 5s linear infinite;
}

@keyframes progressAnimation {
  from { width: 0%; }
  to { width: 100%; }
}

/* Responsive Design pentru Hero */
@media (max-width: 1024px) {
  .slide-content {
    padding: 0 1.5rem;
  }
  
  .carousel-arrow {
    width: 50px;
    height: 50px;
  }
  
  .carousel-arrow-left {
    left: 1rem;
  }
  
  .carousel-arrow-right {
    right: 1rem;
  }
}

@media (max-width: 768px) {
  .hero-carousel {
    z-index: 1; /* Păstrează z-index mic pe mobil */
    height: 70vh;
    min-height: 500px;
  }
  
  .slide-content {
    padding: 0 1rem;
    text-align: left;
  }
  
  .slide-title {
    font-size: clamp(2rem, 10vw, 3.5rem);
    margin-bottom: 0.5rem;
    letter-spacing: -1px;
  }
  
  .slide-subtitle {
    font-size: clamp(1rem, 4vw, 1.2rem);
    margin-bottom: 1.5rem;
  }
  
  .slide-button {
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
  }
  
  .carousel-arrow {
    width: 45px;
    height: 45px;
    opacity: 0.8;
  }
  
  .carousel-dots {
    bottom: 1rem;
    gap: 0.75rem;
  }
  
  .dot {
    width: 10px;
    height: 10px;
  }
}

@media (max-width: 480px) {
  .hero-carousel {
    height: 60vh;
    min-height: 400px;
  }
  
  .slide-content {
    padding: 0 1rem;
  }
  
  .carousel-arrow-left {
    left: 0.5rem;
  }
  
  .carousel-arrow-right {
    right: 0.5rem;
  }
  
  .slide-button {
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
  }
}

/* Animation for text entrance */
@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide.active .slide-title {
  animation: slideInFromLeft 0.8s ease forwards;
  animation-delay: 0.2s;
}

.slide.active .slide-subtitle {
  animation: slideInFromLeft 0.8s ease forwards;
  animation-delay: 0.4s;
}

.slide.active .slide-button {
  animation: slideInFromBottom 0.8s ease forwards;
  animation-delay: 0.6s;
}

/* Smooth transitions for better UX */
.slide {
  will-change: transform;
}

/* Accessibility improvements */
.carousel-arrow:focus,
.dot:focus,
.slide-button:focus {
  outline: 2px solid var(--white);
  outline-offset: 2px;
}

/* Pause animation on hover for better UX */
.hero-carousel:hover .progress-bar {
  animation-play-state: paused;
}`, "",{"version":3,"sources":["webpack://./src/components/HeroCarousel.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;EACjD,yBAAyB;EACzB,cAAc,EAAE,sCAAsC;EACtD,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,cAAc,EAAE,iDAAiD;EACnE;;EAEA,uDAAuD;EACvD;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,eAAe,EAAE,kDAAkD;EACnE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,+BAA+B,EAAE,yCAAyC;EAC1E,2BAA2B;EAC3B,mCAAmC;EACnC,2DAA2D;EAC3D,eAAe,EAAE,4CAA4C;AAC/D;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,uBAAuB,EAAE;;AAE9D;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc,EAAE,oCAAoC;EACtD;;EAEA;IACE,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe,EAAE,kCAAkC;EACrD;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;;AAE5C;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU,EAAE,qCAAqC;AACnD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,+DAA+D;EAC/D,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,mEAAmE;EAC/E,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU,EAAE,gDAAgD;EAC5D,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,UAAU,EAAE,oCAAoC;AAClD;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE,OAAO,SAAS,EAAE;EAClB,KAAK,WAAW,EAAE;AACpB;;AAEA,kCAAkC;AAClC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU,EAAE,mCAAmC;IAC/C,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;;;EAGE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B","sourcesContent":["/* ========== NAVBAR CSS ========== */\n:root {\n  --primary-gray: #d9d9d9;\n  --white: #ffffff;\n  --black: #000000;\n  --transparent: rgba(255, 255, 255, 0.1);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.navbar {\n  background: var(--transparent);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(217, 217, 217, 0.1);\n  transition: all 0.3s ease;\n  z-index: 99999; /* Z-index foarte mare pentru navbar */\n  position: relative;\n}\n\n/* Sticky only on desktop */\n@media (min-width: 769px) {\n  .navbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 99999; /* Păstrează z-index mare pentru fixed position */\n  }\n  \n  /* Add padding to body to compensate for fixed navbar */\n  body {\n    padding-top: 80px;\n  }\n}\n\n.navbar-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  background-color: #ffffff;\n  z-index: 99999;\n}\n\n/* Logo Styles */\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: bold;\n  color: var(--white);\n  z-index: 99999;\n  position: relative;\n}\n\n.logo-f {\n  background: var(--primary-gray);\n  color: var(--black);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.logo-text {\n  color: #000000;\n  font-size: 1.6rem;\n  letter-spacing: 2px;\n  font-weight: 400;\n}\n\n/* Desktop Menu */\n.desktop-menu {\n  display: flex;\n  list-style: none;\n  gap: 2rem;\n  z-index: 99999;\n  position: relative;\n}\n\n.desktop-menu li a {\n  color: var(--black);\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  position: relative;\n  padding: 0.5rem 0;\n}\n\n.desktop-menu li a:hover {\n  color: var(--black);\n}\n\n.desktop-menu li a::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 1px;\n  background: var(--white);\n  transition: width 0.3s ease;\n}\n\n.desktop-menu li a:hover::after {\n  width: 100%;\n}\n\n/* Mobile Menu Button */\n.mobile-menu-button {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 0.5rem;\n  z-index: 100001; /* Cel mai mare z-index pentru butonul hamburger */\n  position: relative;\n}\n\n.hamburger {\n  width: 25px;\n  height: 2px;\n  background: rgb(110, 110, 110);\n  margin: 3px 0;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.mobile-menu-button.active .hamburger:nth-child(1) {\n  transform: rotate(45deg) translate(6px, 6px);\n}\n\n.mobile-menu-button.active .hamburger:nth-child(2) {\n  opacity: 0;\n}\n\n.mobile-menu-button.active .hamburger:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n}\n\n/* Mobile Menu */\n.mobile-menu {\n  position: fixed;\n  top: 0;\n  right: -100%;\n  width: 280px;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.95); /* Background solid pentru vizibilitate */\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  transition: right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  z-index: 100000; /* Z-index foarte mare pentru meniul mobil */\n}\n\n.mobile-menu.active {\n  right: 0;\n}\n\n.mobile-menu-items {\n  list-style: none;\n  padding: 100px 2rem 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  z-index: 100000;\n  position: relative;\n}\n\n.mobile-menu-items li {\n  opacity: 0;\n  transform: translateX(30px);\n  transition: all 0.3s ease;\n  transition-delay: 0.1s;\n  z-index: 100000;\n  position: relative;\n}\n\n.mobile-menu.active .mobile-menu-items li {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.mobile-menu-items li:nth-child(1) { transition-delay: 0.1s; }\n.mobile-menu-items li:nth-child(2) { transition-delay: 0.15s; }\n.mobile-menu-items li:nth-child(3) { transition-delay: 0.2s; }\n.mobile-menu-items li:nth-child(4) { transition-delay: 0.25s; }\n.mobile-menu-items li:nth-child(5) { transition-delay: 0.3s; }\n.mobile-menu-items li:nth-child(6) { transition-delay: 0.35s; }\n\n.mobile-menu-items li a {\n  color: var(--primary-gray);\n  text-decoration: none;\n  font-size: 1.1rem;\n  font-weight: 300;\n  padding: 1rem 0;\n  display: block;\n  transition: all 0.3s ease;\n  border-bottom: 1px solid rgba(217, 217, 217, 0.1);\n  position: relative;\n  z-index: 100000;\n}\n\n.mobile-menu-items li a:hover {\n  color: var(--white);\n  padding-left: 1rem;\n}\n\n/* Menu Overlay */\n.menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 99998; /* Sub meniu dar deasupra hero */\n}\n\n.menu-overlay.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .navbar {\n    z-index: 99999; /* Păstrează z-index mare pe mobil */\n  }\n  \n  .navbar-container {\n    padding: 1rem 1.5rem;\n    z-index: 99999;\n  }\n  \n  .desktop-menu {\n    display: none;\n  }\n  \n  .mobile-menu-button {\n    display: flex;\n    z-index: 100001; /* Cel mai mare z-index pe mobil */\n  }\n  \n  .logo-text {\n    font-size: 1rem;\n    letter-spacing: 1.5px;\n  }\n  \n  .logo-f {\n    width: 28px;\n    height: 28px;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar-container {\n    padding: 1rem 1rem;\n    z-index: 99999;\n  }\n  \n  .mobile-menu {\n    width: 100%;\n    z-index: 100000;\n  }\n  \n  .mobile-menu-items {\n    padding: 80px 2rem 2rem;\n    z-index: 100000;\n  }\n}\n\n/* Smooth scrolling for anchor links */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Hide scrollbar when menu is open */\nbody.menu-open {\n  overflow: hidden;\n}\n\n/* ========== HERO CAROUSEL CSS ========== */\n\n.hero-carousel {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  min-height: 600px;\n  overflow: hidden;\n  background: var(--black);\n  z-index: 1; /* Z-index mic pentru hero carousel */\n}\n\n.carousel-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n/* Slides */\n.slides-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  z-index: 1;\n}\n\n.slide-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    135deg,\n    rgba(0, 0, 0, 0.6) 0%,\n    rgba(0, 0, 0, 0.3) 50%,\n    rgba(0, 0, 0, 0.1) 100%\n  );\n  z-index: 2;\n}\n\n.slide-content {\n  position: relative;\n  z-index: 3; /* Doar pentru conținutul slide-ului, nu pentru întreaga secțiune */\n  max-width: 1200px;\n  padding: 0 2rem;\n  margin-left: 0;\n  opacity: 0;\n  transform: translateY(50px);\n  transition: all 0.8s ease;\n  transition-delay: 0.3s;\n}\n\n.slide.active .slide-content {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.slide-title {\n  font-size: clamp(2.5rem, 8vw, 6rem);\n  font-weight: 300;\n  color: var(--white);\n  margin: 0 0 1rem 0;\n  line-height: 1.1;\n  letter-spacing: -2px;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  max-width: 800px;\n}\n\n.slide-subtitle {\n  font-size: clamp(1.1rem, 2vw, 1.5rem);\n  color: var(--primary-gray);\n  margin: 0 0 2rem 0;\n  font-weight: 300;\n  opacity: 0.9;\n  line-height: 1.4;\n  max-width: 600px;\n}\n\n.slide-button {\n  background: transparent;\n  border: 2px solid var(--white);\n  color: var(--white);\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.slide-button:hover {\n  background: var(--white);\n  color: var(--black);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2);\n}\n\n.slide-button svg {\n  transition: transform 0.3s ease;\n}\n\n.slide-button:hover svg {\n  transform: translateX(5px);\n}\n\n/* Navigation Arrows */\n.carousel-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--white);\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 5; /* Z-index mic pentru elementele carousel-ului */\n  opacity: 0.7;\n}\n\n.carousel-arrow:hover {\n  background: rgba(255, 255, 255, 0.2);\n  opacity: 1;\n  transform: translateY(-50%) scale(1.1);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.carousel-arrow-left {\n  left: 2rem;\n}\n\n.carousel-arrow-right {\n  right: 2rem;\n}\n\n/* Dots Indicator */\n.carousel-dots {\n  position: absolute;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 1rem;\n  z-index: 5; /* Z-index mic pentru dots */\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dot.active {\n  background: var(--white);\n  transform: scale(1.2);\n}\n\n.dot:hover:not(.active) {\n  background: rgba(255, 255, 255, 0.6);\n  transform: scale(1.1);\n}\n\n/* Progress Bar */\n.carousel-progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.2);\n  z-index: 5; /* Z-index mic pentru progress bar */\n}\n\n.progress-bar {\n  height: 100%;\n  background: var(--white);\n  width: 0;\n  animation: progressAnimation 5s linear infinite;\n}\n\n@keyframes progressAnimation {\n  from { width: 0%; }\n  to { width: 100%; }\n}\n\n/* Responsive Design pentru Hero */\n@media (max-width: 1024px) {\n  .slide-content {\n    padding: 0 1.5rem;\n  }\n  \n  .carousel-arrow {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .carousel-arrow-left {\n    left: 1rem;\n  }\n  \n  .carousel-arrow-right {\n    right: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-carousel {\n    z-index: 1; /* Păstrează z-index mic pe mobil */\n    height: 70vh;\n    min-height: 500px;\n  }\n  \n  .slide-content {\n    padding: 0 1rem;\n    text-align: left;\n  }\n  \n  .slide-title {\n    font-size: clamp(2rem, 10vw, 3.5rem);\n    margin-bottom: 0.5rem;\n    letter-spacing: -1px;\n  }\n  \n  .slide-subtitle {\n    font-size: clamp(1rem, 4vw, 1.2rem);\n    margin-bottom: 1.5rem;\n  }\n  \n  .slide-button {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.9rem;\n  }\n  \n  .carousel-arrow {\n    width: 45px;\n    height: 45px;\n    opacity: 0.8;\n  }\n  \n  .carousel-dots {\n    bottom: 1rem;\n    gap: 0.75rem;\n  }\n  \n  .dot {\n    width: 10px;\n    height: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-carousel {\n    height: 60vh;\n    min-height: 400px;\n  }\n  \n  .slide-content {\n    padding: 0 1rem;\n  }\n  \n  .carousel-arrow-left {\n    left: 0.5rem;\n  }\n  \n  .carousel-arrow-right {\n    right: 0.5rem;\n  }\n  \n  .slide-button {\n    padding: 0.6rem 1.2rem;\n    font-size: 0.85rem;\n  }\n}\n\n/* Animation for text entrance */\n@keyframes slideInFromLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInFromBottom {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.slide.active .slide-title {\n  animation: slideInFromLeft 0.8s ease forwards;\n  animation-delay: 0.2s;\n}\n\n.slide.active .slide-subtitle {\n  animation: slideInFromLeft 0.8s ease forwards;\n  animation-delay: 0.4s;\n}\n\n.slide.active .slide-button {\n  animation: slideInFromBottom 0.8s ease forwards;\n  animation-delay: 0.6s;\n}\n\n/* Smooth transitions for better UX */\n.slide {\n  will-change: transform;\n}\n\n/* Accessibility improvements */\n.carousel-arrow:focus,\n.dot:focus,\n.slide-button:focus {\n  outline: 2px solid var(--white);\n  outline-offset: 2px;\n}\n\n/* Pause animation on hover for better UX */\n.hero-carousel:hover .progress-bar {\n  animation-play-state: paused;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
